import { useFieldArray, UseFormReturn } from 'react-hook-form';

import { CommissionsCreateFormValues, CommissionStepFormValues } from '../CommissionsCreateForm';

type UseCommissionStepsFieldReturnValues = {
  stepsFields: Record<'id', string>[];
  onAddStepClick: () => void;
  onRemoveStepClick: (index: number) => void;
};

type Props = {
  name: 'ladder.steps';
  form: UseFormReturn<CommissionsCreateFormValues, any>;
};

export function getInitialStep(index: number): CommissionStepFormValues {
  return {
    stepNumber: index,
    thresholdFrom: null,
    thresholdTo: null,
    commissionRate: {
      percent: null,
      fix: null,
      min: null,
      max: null,
    },
  };
}

export function useLadderField({ name, form }: Props): UseCommissionStepsFieldReturnValues {
  const {
    fields: stepsFields,
    append: appendStep,
    remove: removeStep,
  } = useFieldArray({
    name,
    control: form.control,
  });

  function onAddStepClick(): void {
    appendStep(getInitialStep(stepsFields.length + 1));
  }

  return {
    stepsFields,
    onAddStepClick,
    onRemoveStepClick: removeStep,
  };
}
